const STORAGE_KEY = "crmWaInboxUnread";
export const WA_INBOX_UNREAD_EVENT = "crm-whatsapp-unread";

function readCount() {
  const n = Number(sessionStorage.getItem(STORAGE_KEY) || 0);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
}

function writeCount(n) {
  const next = Math.max(0, Math.floor(n) || 0);
  if (next <= 0) sessionStorage.removeItem(STORAGE_KEY);
  else sessionStorage.setItem(STORAGE_KEY, String(next));
  window.dispatchEvent(
    new CustomEvent(WA_INBOX_UNREAD_EVENT, { detail: { count: next } }),
  );
  return next;
}

export function getWhatsAppInboxUnread() {
  return readCount();
}

export function bumpWhatsAppInboxUnread(by = 1) {
  return writeCount(readCount() + Math.max(1, by));
}

export function clearWhatsAppInboxUnread() {
  return writeCount(0);
}
